import { render } from "./OTPLoginVerifyForm.vue?vue&type=template&id=75f7c0d8&ts=true"
import script from "./OTPLoginVerifyForm.vue?vue&type=script&lang=ts"
export * from "./OTPLoginVerifyForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Authentication/Login/OTPLoginVerifyForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75f7c0d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75f7c0d8', __exports__)) {
    api.reload('75f7c0d8', __exports__)
  }
  
  module.hot.accept("./OTPLoginVerifyForm.vue?vue&type=template&id=75f7c0d8&ts=true", () => {
    api.rerender('75f7c0d8', render)
  })

}


export default __exports__